import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absences', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absences/' + id);
}

const updateAbsenceData = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/leave/absences/' + id, formData);
}

const downloadFile = async (method, uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absences/download/' + uuid, {responseType: 'arraybuffer'});
}

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/approval/step/update/status/' + id, formData);
}

const getLeaveForm = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absences/form');
}

const storeLeaveForm = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/leave/absences', formData);
}

const studentRequests = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absences/student');
}

const downloadAsExcel = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absences/excel-export',{...config,responseType:'arraybuffer'});
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/leave/absences/' + id);
}

const storeMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/leave/absence/message', formData);
}

const getMessages = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/leave/absence/messages/' + id);
}


export default {
    getAll,
    get,
    downloadFile,
    update,
    getLeaveForm,
    storeLeaveForm,
    studentRequests,
    downloadAsExcel,
    del,
    storeMessage,
    getMessages,
    updateAbsenceData
}
